var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filled_heart 2",
    clipPath: "url(#clip0_282_2341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0026 19.6416C10.7351 19.6396 10.4789 19.5334 10.2885 19.3456L1.79854 10.8555C0.643828 9.70083 -0.00488281 8.13471 -0.00488281 6.50169C-0.00488281 4.86868 0.643828 3.30256 1.79854 2.14784C2.95325 0.993132 4.51938 0.344421 6.15239 0.344421C7.7854 0.344421 9.35153 0.993132 10.5062 2.14784L11.0156 2.65289L11.5207 2.14784C12.6754 0.993132 14.2415 0.344421 15.8745 0.344421C17.5075 0.344421 19.0737 0.993132 20.2284 2.14784C21.3831 3.30256 22.0318 4.86868 22.0318 6.50169C22.0318 8.13471 21.3831 9.70083 20.2284 10.8555L11.7123 19.3456C11.524 19.5339 11.2689 19.6404 11.0026 19.6416Z",
    fill: "#B8BCBF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_2341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19.2832,
    fill: "white",
    transform: "translate(0 0.358398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.9444a4eafc9841052d176b10ab184c8f.svg";
export { ForwardRef as ReactComponent };